import { Component } from '@angular/core';

@Component({
    selector: 'app-mp-profile-information',
    imports: [],
    templateUrl: './mp-profile-information.component.html',
    styleUrl: './mp-profile-information.component.scss'
})
export class MpProfileInformationComponent {}